import { Box, RadioGroup } from '@chakra-ui/react'
import { BgColors, TextColors } from 'commons/design-system/tokens'
import type { PropsWithChildren } from 'react'

type Props = PropsWithChildren<{ value: string }>

export const AmountRadioButton = ({ children, value }: Props) => {
	return (
		<RadioGroup.Item
			value={value}
			cursor='pointer'
			borderRadius='full'
			fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
			fontSize='14px'
			lineHeight='21px'
			fontWeight={700}
			h='full'
			bg={BgColors.Z4}
			color={TextColors.TERTIARY}
			transition='0.22s ease-out background-color'
			whiteSpace='nowrap'
			_hover={{ bg: BgColors.Z2 }}
			_checked={{
				bg: BgColors.STATUS_INFO,
				color: BgColors.OPPOSITE_Z3,
				outline: '2px solid',
				outlineColor: BgColors.OPPOSITE_Z3,
				outlineOffset: '-2px'
			}}
			_focus={{
				outline: '2px solid',
				outlineColor: BgColors.OPPOSITE_Z3,
				outlineOffset: '-2px',
				boxShadow: 'none'
			}}
			px={{ base: 3, sm: 5 }}
			py={3}
		>
			<RadioGroup.ItemHiddenInput />
			<Box as='span'>{children}</Box>
		</RadioGroup.Item>
	)
}
